import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Paypal: React.FC<IconProps> = ({ color, size, style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? '21'}
      height={size ?? '21'}
      fill="none"
      viewBox="0 0 21 21"
      id="paypal-svg-1"
      data-testid="paypal-icon"
    >
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          x1={-10.767}
          y1={4.675}
          x2={-11.233}
          y2={-22.851}
          gradientTransform="matrix(.77606 0 0 .75 18.576 17.229)"
        >
          <stop
            offset={0}
            style={{
              stopColor: '#e1e1e1',
              stopOpacity: 1,
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: '#f4f4ff',
              stopOpacity: 1,
            }}
          />
        </linearGradient>
        <linearGradient
          id="paypal-b"
          gradientUnits="userSpaceOnUse"
          x1={-26.303}
          y1={29.398}
          x2={-23.612}
          y2={16.456}
          gradientTransform="matrix(.46392 0 0 .46392 22.31 3.711)"
        >
          <stop
            stopColor={color ?? '#1b92f4'}
            offset={0}
            style={{
              stopOpacity: 1,
            }}
          />
          <stop
            stopColor={color ?? '#20b9fa'}
            offset={1}
            style={{
              stopOpacity: 1,
            }}
          />
        </linearGradient>
        <linearGradient
          id="paypal-c"
          gradientUnits="userSpaceOnUse"
          x1={-31.916}
          y1={25.328}
          x2={-26.13}
          y2={0.304}
          gradientTransform="matrix(.46392 0 0 .46392 22.31 3.711)"
        >
          <stop
            offset={0}
            style={{
              stopColor: '#222d65',
              stopOpacity: 1,
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: '#3b4eaf',
              stopOpacity: 1,
            }}
          />
        </linearGradient>
      </defs>
      <path
        fill={color ?? '#253b80'}
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fillOpacity: 1,
        }}
        d="m7.938 17.027.242-1.543-.54-.011H5.06L6.852 4.102a.16.16 0 0 1 .05-.09A.15.15 0 0 1 7 3.977h4.352c1.445 0 2.441.3 2.96.894.243.277.399.566.473.887.082.336.082.738.004 1.226l-.004.036v.316l.242.137c.207.109.371.234.496.379.207.238.344.539.399.898.062.367.043.809-.055 1.305-.113.57-.293 1.066-.535 1.476a3.015 3.015 0 0 1-.848.926c-.32.23-.707.402-1.14.516-.418.109-.899.164-1.422.164h-.34c-.242 0-.477.086-.664.242-.184.16-.305.379-.344.617l-.027.14-.426 2.716-.02.101c-.007.031-.015.047-.027.055a.065.065 0 0 1-.047.02h-2.09"
      />
      <path
        fill={color ?? 'url(#paypal-b)'}
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
        }}
        d="m15.262 7.059-.047.253c-.574 2.946-2.535 3.965-5.043 3.965H8.895a.618.618 0 0 0-.614.524l-.652 4.148-.188 1.172c-.03.2.122.379.325.379h2.261c.27 0 .496-.195.54-.457l.023-.117.426-2.707.027-.149a.542.542 0 0 1 .539-.457h.34c2.191 0 3.91-.89 4.41-3.468.211-1.079.102-1.977-.453-2.61a2.154 2.154 0 0 0-.617-.476"
      />
      <path
        fill={color ?? 'url(#paypal-c)'}
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
        }}
        d="M7 3.5a.621.621 0 0 0-.613.527L4.574 15.516a.374.374 0 0 0 .367.433H7.63l.652-4.148c.051-.301.309-.524.614-.524h1.277c2.508 0 4.469-1.02 5.043-3.964.02-.086.035-.172.047-.254.172-1.09 0-1.832-.59-2.504-.649-.739-1.82-1.055-3.32-1.055H7"
      />
    </svg>
  );
};

export default Paypal;
